/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { ROUTES } from "../constants/constants";
import { FlowType } from "../store/slices/flowSlice";

/**
 * In-app version of the transition the normal full-page-reload return flow does: write the
 * #sb-widget-callback/... hash the status page parses on mount. No _at token needed - the session
 * was never lost. Used by useNavigateToPaymentStatus and by DefaultRouteHandler on boot.
 */
export const writePaymentCallbackHash = (invoiceId, system) => {
  window.location.hash =
    `#sb-widget-callback/ext/invoice-payment/return/system/${encodeURIComponent(system)}` +
    `/invoice_id/${encodeURIComponent(invoiceId)}`;
};

/** Same mapping useRedirectRoutes applies. */
export const getPaymentStatusRoute = (activeFlow) =>
  activeFlow === FlowType.CART ? ROUTES.CART_ITEM_STATUS : ROUTES.BOOKING_STATUS;
